const KEY = 'waymorr_current_hosting';
const EVENT = 'hosting-changed';

// storage event срабатывает только в других вкладках, поэтому шлём кастомное окно
// для той же вкладки -- listing-страницы триггерят refetch и при сбросе крестиком,
// когда URL ?hosting_id и так был пустым.
const dispatch = (id) => {
  try {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { id: id || null } }));
  } catch (e) {}
};

export const getCurrentHostingId = () => {
  try {
    return localStorage.getItem(KEY) || null;
  } catch (e) {
    return null;
  }
};

export const setCurrentHostingId = (id) => {
  try {
    if (id) {
      localStorage.setItem(KEY, id);
      dispatch(id);
    }
  } catch (e) {}
};

export const clearCurrentHostingId = () => {
  try {
    localStorage.removeItem(KEY);
    dispatch(null);
  } catch (e) {}
};

export const HOSTING_CHANGED_EVENT = EVENT;
